<template>
  <div class="search-results-playlist">
    <div class="results">
      <div v-for="(result, index) in getSearchResults" :key="index">
        <div class="playlist-item">
          <div :style="coverBackgroundImage(result)" class="cover" @click="goToResultPage(result)">
            <!--  -->
          </div>
          <div class="info" @click="goToResultPage(result)">
            <div class="name" v-html="result.name" />
            <div class="created">
              <div class="avatar">
                <img v-img-loader
                     :data-default-src="'/img/img-default/img-user-default-l.png'"
                     :data-src="result.member.avatar" alt="user image"
                >
              </div>
              <div class="text">
                {{ $t('PLAYLIST.CREATED_BY', {member: result.member.name}) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="(index + 1) % 10 === 0 || (index + 1) === getSearchResults.length" class="pgnnp-item">
          <Paganiniplus />
        </div>
      </div>
    </div>
    <SearchNoResultsText :results="getSearchResults" />
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import SearchNoResultsText from '@/components/search/SearchNoResultsText'
import LoggerService from '@/assets/services/LoggerService'
import ImgLoader from '@/directives/ImgLoader'

export default {
  name: 'SearchResultsPlaylist',
  components: {
    Paganiniplus,
    SearchNoResultsText
  },
  directives: {
    ImgLoader
  },
  props: {
    resultType: {
      type: String,
      default: 'playlist'
    }
  },
  data() {
    return {}
  },
  computed: {
    getSearchResults() {
      const matchedSearchObj = this.$store.getters.getSearchResults.find(searchObj => searchObj[this.resultType])
      return matchedSearchObj[this.resultType] || []
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    coverBackgroundImage(result) {
      return result && result['file_link']
        ? { backgroundImage: `url(${result['file_link']})` }
        : {}
    },
    goToResultPage(result) {
      this.$router.push({ name: 'playlistById', params: { id: result.id } })
      //
      this.logRecord(result)
    },
    logRecord(result) {
      const params = {
        userId: this.$store.getters.getProfile.id || '',
        peopleCookieId: window.localStorage.getItem('fingerprint') || '',
        refer: document.referrer || this.$route.query.refer || '',
        keyword: this.$store.getters.getSearchedKeyword || '',
        clickUrl: `${window.location.protocol}//${window.location.host}/${this.$i18n.localePath()}/playlists/${result.id}`,
        agent: window.navigator.userAgent,
        trackId: '',
        playlistId: result.id
      }
      LoggerService.logUserSearchAction(params)
      // gtag event
      const searchItemData = `[playlist] ${result.name} ${result.id}`
      this.$store.dispatch('GTAG_EVENT', {
        action: 'view_search_results',
        data: { 'search_term': searchItemData }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.results {
  .pgnnp-item {
    margin: 36px 0;
  }
  .playlist-item {
    width: 50%;
    float: left;
    position: relative;
    overflow: hidden;
    margin-bottom: 36px;
    .cover {
      position: relative;
      overflow: hidden;
      float: left;
      width: 130px;
      height: 116px;
      margin-right: 24px;
      border-radius: 12px;
      cursor: pointer;

      background-color: $grey-ec;
      background-image: url('/img/img-default/img-playlist-default-l.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      img {
        width: 130px;
        height: 116px;
        border-radius: 12px;
      }
    }
    .info {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      .name {
        height: 39px;
        margin-bottom: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 1.63;
        color: $grey-50;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .created {
        min-height: 36px;
        margin-bottom: 16px;
        .avatar,
        .text  {
          position: relative;
          overflow: hidden;
        }
        .avatar {
          float: left;
          width: 36px;
          margin-right: 8px;
          img {
            height: 36px;
            border-radius: 50%;
          }
        }
        .text {
          font-size: 20px;
          line-height: 36px;
          letter-spacing: -0.1px;
          color: $grey-50;

          white-space: nowrap;
          // overflow: hidden; // exist by BFC
          text-overflow: ellipsis;
        }

      }
    }
  }
  &::after {
    content: "";
    display: block;
    clear: both;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .results {
    .playlist-item {
      width: 100%;
      margin-bottom: 24px;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .results {
    .playlist-item {
      width: 100%;
      margin-bottom: 16px;
    }
  }
}

@media only screen and (max-width: 368.98px) {
  .results {
    .pgnnp-item {
      margin: 36px -24px;
    }
  }
}
</style>
